import { Navigate, useLocation } from 'react-router-dom';

/** Old /recovery-drink URLs land on Recovery, keeping ride query params. */
export default function RecoveryDrinkRedirect() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/recovery', search }} replace />;
}
